import { ThemeProperties } from "./types";

const uglaTheme: ThemeProperties = {
    name : "ugla",
    logo : {
        src : '/img/ugla-logo.png',
        alt : "Logo Ugla"
    },
    gradients : {
        leftSideBarBackground : 'linear-gradient(180deg, #0B2A63, #0164AB 50%, #0B2A63 100%)',
        selectionPageBackground : 'linear-gradient(135deg, #667eea 0%, #4b61a2ff 100%)',
    },
    colors : {
        backButtonBackground : '#00ABDE',
        viewItemBackground : '#ffffff',
        viewItemHoverBackground : '#ffffffee',
        bottomPanelBackground : '#0164AB',
        itemContainerBackground : '#00406dbb',
        itemContainerSelectedBackground : '#3689c4',
        itemContainerHoverBackground : '#3689c4c0',
        selectedBadgeBackground : '#2f559b',
        panoramicViewBackground : '#0d477070',
    },
};

export default uglaTheme;